import { createContext, FC, PropsWithChildren, useState } from "react";

interface LightBoxContxt {
    open: boolean,
    setOpen: React.Dispatch<React.SetStateAction<boolean>>,
    images: string[],
    setImages: React.Dispatch<React.SetStateAction<string[]>>
}

const LightBoxContext = createContext<LightBoxContxt | undefined>(undefined);

export const LightBoxProvider: FC<PropsWithChildren> = ({ children }) => {
    const [open, setOpen] = useState<boolean>(false);
    const [images, setImages] = useState<string[]>([]);

    return (
        <LightBoxContext.Provider
            value={{
                open,
                setOpen,
                images,
                setImages
            }}>
            {children}
        </LightBoxContext.Provider>
    )
}

export default LightBoxContext;